import http from "./httpService";
import download from 'downloadjs';

const apiEndpoint = "/reports";

export async function getReport(reportName, parameters = {}, format = "PDF") {
  // Ensure parameters is an object
  if (typeof parameters !== 'object' || Array.isArray(parameters)) {
    console.error("Invalid parameters. Expected an object.");
    return;
  }

  // Start with the base URL
  let url = `${apiEndpoint}/${reportName}?`;

  // Check if the parameters is a valid object and iterate over them
  Object.entries(parameters).forEach(([key, value], i) => {
    if (value) {
      url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      if (i !== Object.entries(parameters).length - 1) url += "&";
    }
  });

  // Add the format parameter at the end of the query string
  url += `&format=${format}`;

  let fileExt = format.toLowerCase() === "excel" ? ".xls" : ".pdf";

  console.log("Fetching Report:", url);

  try {
    const response = await http.get(url, {
      responseType: "blob",
    });

    const contentType = response.headers["content-type"];
    download(response.data, `${reportName}${fileExt}`, contentType);
  } catch (error) {
    console.error("Error fetching report:", error);
  }
}
